
// GENERAL
export const SET_GENERAL = "SET_GENERAL";
export function setGeneral(payload:any) {
    return { type: SET_GENERAL, payload };
}